import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "FilePdf",
  "use": "FilePdf-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"FilePdf\"><path fill=\"#fff\" fill-opacity=\".01\" d=\"M0 0h24v24H0z\" /><path d=\"M18 12h1a1 1 0 0 1 0 2h-1v2a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-1v2ZM6 12h1v-2H6v2Zm0 2v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4a.998.998 0 0 1-1 1H6Zm5.5 3h-1a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5H14a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-2.5Zm.5-2h1v-5h-1v5Z\" fill=\"#1976D2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol